export default __webpack_public_path__ + "static/media/Nozzle, Green.5e23c07d.png";